import React, { useState, useEffect, useContext, Component,useRef } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
 
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
 
// import required modules
import { Pagination, Navigation,Autoplay } from 'swiper/modules';

import { useBlogContext } from '../../fetchdata/BlogContext';

const HomeLocation = () => {


    const {
      
      isLayoutLoading,
      layout,
    } = useBlogContext();


  const swiperRefLocal = useRef()

  const handleMouseEnter = () => {
      swiperRefLocal?.current?.swiper?.autoplay?.stop()
  };

  const handleMouseLeave = () => {
      swiperRefLocal?.current?.swiper?.autoplay?.start()
  };


  const [loading, setloading] = useState(true);

  const [Data, setData] = useState([]);
  const [serviceSearch, setServiceSearch] = useState("");
  const [showAllServices, setShowAllServices] = useState(false);
  const { slug } = useParams();

  const SERVICE_LIMIT = 12;
  const filteredServices = Data.filter((category) =>
    category.title?.toLowerCase().includes(serviceSearch.trim().toLowerCase())
  );
  const visibleServices = showAllServices
    ? filteredServices
    : filteredServices.slice(0, SERVICE_LIMIT);
  const hasMoreServices = filteredServices.length > SERVICE_LIMIT;


  const getBlog = async () => {
    const modifiedSlug = slug.replace(/-/g, ' '); // This will remove all hyphens

    setloading(true);
    try {
      const { data } = await axiosInstance.get(`/get-catgeory-product?location=${modifiedSlug}`);
      setData(data.categoriesWithProducts || []);
      setShowAllServices(false);
      // Delay the execution of buildScript by 1 secon
      console.log('datadata',data);

    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }


  };




  useEffect(() => {
    getBlog();
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <>
      <Header />
   



      <main className="page py-4">
     
{loading ? <> 

  <div className='d-flex justify-content-center align-items-center' style={{minHeight:'80vh'}}>
  <div class="spinner-border" role="status" style={{width:100,height:100}}>
 </div>
</div>

</> : 
<>
{Data.length === 0 ?
<>
<div className='d-flex justify-content-center align-items-center' style={{minHeight:'80vh'}}>
  <div className='text-center'>
  <h1>Oops! That page can't be found.
  </h1>
  <p>It looks like nothing was found at this location. Maybe try a search?</p>
  <Link to="/" className='btn btn-primary'> GO HOME</Link>
  </div>
</div>

</>
:
<>

   {/* Hero Section */}
   <div className="container mt-4 position-relative">
          <div className="row">
            {isLayoutLoading ? (
              <>
                <div className="col-md-12 pt-4">
                  <div
                    className="skeleton w-100 "
                    style={{
                      width: 1500,
                      maxWidth: "100% ",
                      height: "auto",
                      aspectRatio: "1500/1350",
                      borderRadius: 20,
                    }}
                  />
                </div>
              </>
            ) : (
              <div className="w-100 home-hero position-relative overflow-hidden rounded-xl">

              <div className="col-md-12 pt-4 hero-banner position-absolute " style={{zIndex:'-1'}}>
                <img
                  src={
                    layout.slider_img !== ""
                      ? layout.slider_img
                      : "/assets/img/placeholder.png"
                  }
                  width="100%"
                  alt=""
                  style={{
                    width: 1500,
                    maxWidth: "100% ",
                    height: "auto",
                    aspectRatio: "1500/1350",
                    borderRadius: 20,
                    objectFit: "cover",
                  }}
                />
              </div>

              <div className="row z-2 justify-content-between">
                <div class="col-md-7 d-flex align-items-start flex-column justify-content-center ps-md-4 ms-md-4 px-4 py-4">
                <h4 className="mb-4 border-left position-realtive">Browse by Services </h4>

                <div className="w-100 mb-3">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search services"
                    value={serviceSearch}
                    onChange={(event) => {
                      setServiceSearch(event.target.value);
                      setShowAllServices(false);
                    }}
                  />
                </div>

         <div className="row w-100">

         {
visibleServices.map((category, index) => {
  return (
                       <div
                        key={category.slug || index}
                        className="col-md-4 col-6 bg-white p-0 mb-2 shadow" style={{transform:'scale(0.95)'}}
                         
                      >
                        <Link to={`/${slug}/${category.slug}`} className="d-flex align-items-center p-2 gap-2 ">
                          <img
                            src={category.icon_image}
                             alt={category.title} style={{width:50,height:50}}
                            className=" mx-auto "
                          />
                          <p className="text-start m-0 w-100">
                            {category.title}
                          </p>
                        </Link>
                      </div>
                 
                 
  )})}
  {filteredServices.length === 0 && (
    <div className="col-12">
      <p className="mb-0 text-muted">No services found.</p>
    </div>
  )}
        </div>
        {hasMoreServices && (
          <button
            type="button"
            className="btn btn-primary btn-sm mt-2"
            onClick={() => setShowAllServices((current) => !current)}
          >
            {showAllServices ? "Show Less" : "Show More"}
          </button>
        )}
                </div>

                <div class="col-md-4">
                 
                  <img src="/assets/img/drArun.png" className="w-100"/>
                  <div className="bg-primary p-2 rounded mb-2">
                 <h4 className="text-white m-0">  Dr. Arun Kumar Garg </h4> 
                 <p className="m-0 text-white"> Director & Consultant Clinical Cardiology </p> 
                    </div>
                </div>

                </div>

              </div>
            )}

      
          </div>
        </div>
        {/* Hero Section */}

        <div className="container my-2 mt-4 ">
          <div className="row">
            <div className="col-12">
              <h2> Service Category</h2>
            </div>
          </div>
          <div className="row py-2   ">

          {
Data.map((category, index) => {
  return (
    <div className="col-md-2 col-6 mb-2" key={index}>
    <div className="p-0 bg-light-blue rounded">
      <Link className="col py-2 " to={`/${slug}/${category.slug}`}>
        <img
          style={{
            width: "100%",

            objectFit: "cover",
            aspectRatio: "1/0.5",
          }}
          alt={category.title}
          width="100%"
          className="rounded"
          src={category.image}
        />

        <h5 className="text-center text-primary fs-lg px-2 py-2" style={{minHeight:60}}>
          {" "}
          {category.title}{" "}
        </h5>
      </Link>
    </div>
  </div>
                 
                 
  )})}


             
          </div>
        </div>


{ 'dwd' === 'dwdwd' &&
Data.map((category, index) => {
  return (
<>

 
     <div className="container py-4 pt-sm-5 "  key={index} >
       {/* Heading */}
       <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
         <h2 className="h3 mb-0 me-2">{category.title}</h2>
         <div className="ms-n4">
           {/* <a
             className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
             href="#"
           >
             View All
             <i className="ri-arrow-right-line ms-1" />
           </a> */}
         </div>
       </div>
       {/* Heading */}
       {/* Product Cards */}


       <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
         {/* Product Card */}
         <Swiper breakpoints={{
           300: {
             slidesPerView: 1,
             spaceBetween: 10, // Set the gap between slides for window width <= 400px
           },
           768: {
             slidesPerView: 3,
             spaceBetween: 20, // Set the gap between slides for window width <= 768px
           },
           992: {
             slidesPerView: 3,
             spaceBetween: 25, // Set the gap between slides for window width <= 992px
           },
           1200: {
             slidesPerView: 3,
             spaceBetween: 25, // Set the gap between slides for window width <= 1200px
           },
         }}
           pagination={true} navigation={true} modules={[Pagination, Navigation]} className="swiper-wrapper" >
 

         {category?.products.map((product, index) => {
                

                 return (

<SwiperSlide key={index}>

  {/* Product */}
                            <div className="w-100">
                              <div className="card card-product h-100 bg-light border rounded-4 overflow-hidden bgw-white">
                             
                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <Link
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </Link>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                               
                                {/* Preview Image */}
                                <div className="card-body p-2 ">
                                  {/* Product Category */}

                                  {/* <a
                                    className="product-category d-block fs-sm pb-1"
                                    href="#"
                                  >
                                    Smartphones
                                  </a> */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
<div className="col">

<h3 className="product-title  mt-2">
                                    <Link to={`/product/${product.slug}`}>
                                      {" "}
                                      {product.title}{" "}
                                    </Link>
                                  </h3>
</div>
 <div className="col-md-4 text-end">
 <span class="badge btn text-danger bg-white btn-outline-danger">Health</span>

 
 </div>
                                 
                                  </div>

                                  {/* <div className="row justify-content-between w-100 p-0 m-0">
                                    <div className="col">
                                    
                                  
<b className="d-block m-0 p-0">   <i class="ri-microscope-line"></i> {product.features.length} Parameters  </b> 
<div>Include</div>
                                    </div>

                                    <div className="col text-md-end fs-8">
                                    
                                  
                                    <b className="d-block m-0 p-0">   <i class="ri-calendar-todo-fill"></i>
                                     Report  </b> 
                                    <div>Same Day</div>
                                      </div>

                                  </div> */}


                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
                                  <div className="product-price col mt-2 ">
                                    {product.salePrice === 0 ? (
                                      <span
                                        className="text-danger"
                                        style={{ color: "red" }}
                                      >
                                        Price On request
                                      </span>
                                    ) : (
                                      <span className="text-danger fs-5">
                                        ₹{product.salePrice}
                                        <del className="text-body-secondary ms-1">
                                          <small>₹{product.regularPrice}</small>
                                        </del>
                                      </span>
                                    )}

                                  
                                  </div>

                                  <Link className="btn btn-sm btn-primary col-md-1 w-auto mt-2 " to={`/product/${product.slug}`}>
Book Now
                                  </Link>
                                  </div>
                             
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                            </div>
                            {/* Product */}

</SwiperSlide>
              

                 )
               }) }




         </Swiper >

       </div>


       {/* Product Cards */}
     </div>
   
     </>
)})
}

</>

}





</>
}
    
       


   <div className="container my-2 mt-4 ">
        <div className="col-md-12 mt-sm-4">
              <div
                className="hero hero-swiper"
                style={{
                  width: 1400,
                  maxWidth: "100% ",
                  height: "auto",
                  aspectRatio: "1400/400",
                  borderRadius: 15,
                  overflow: "hidden",
                }}
              >
                {isLayoutLoading ? (
                  <>
                    <div
                      className="skeleton w-100"
                      style={{
                        width: 1500,
                        maxWidth: "100% ",
                        height: "auto",
                        aspectRatio: "1400/400",
                      }}
                    ></div>
                  </>
                ) : (
                  <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Swiper
                      pagination={true}
                      navigation={true}
                      gap={"30"}
                      ref={swiperRefLocal}
                      autoplay={{
                        delay: 1500,
                        pauseOnMouseEnter: true,
                      }}
                      loop={true}
                      modules={[Pagination, Navigation, Autoplay]}
                      className="swiper-wrapper"
                      style={{
                        width: 1400,
                        maxWidth: "100% ",
                        height: "auto",
                        aspectRatio: "1400/400",
                        borderRadius: 15,
                        overflow: "hidden",
                      }}
                    >
                      {layout.home_slider && (
                        <>
                          {layout.home_slider.map((image, index) => (
                            <SwiperSlide key={index}>
                              <img
                                className="img-fluid w-100"
                                src={image}
                                alt="Product"
                              />
                            </SwiperSlide>
                          ))}
                        </>
                      )}
                    </Swiper>
                  </div>
                )}
              </div>
            </div>
            </div>
 

        <div className="container mt-4">
          <Swiper
            breakpoints={{
              300: {
                slidesPerView: 1,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 15, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 2,
                spaceBetween: 15, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 2,
                spaceBetween: 20, // Set the gap between slides for window width <= 1200px
              },
            }}
            pagination={true}
            modules={[Pagination, Navigation]}
            className="swiper-wrapper"
          >
            {isLayoutLoading
              ? Array.from({ length: 3 }).map((_, index) => (
                <SwiperSlide>
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/0.3",
                    }}
                  ></div>
                </SwiperSlide>
              ))
              : layout.service_banner_images && (
                <>
                  {layout.service_banner_images.map((image, index) => (
                    <SwiperSlide
                      key={index}
                      className="container my-4 py-2 d-block"
                    >
                      <Link to={image.imageUrlInput} className="w-100s">
                        <img
                          src={image.imageInput}
                          width="100%"
                          alt=""
                          className="w-100"
                        />
                      </Link>
                    </SwiperSlide>
                  ))}
                </>
              )}
          </Swiper>
        </div>

        <div className="container my-2 mt-4">
          <div className="row">
            <div className="col-md-5">
              <img
                alt=""
                src={layout.collection_img}
                width="100%"
                style={{ width: "100%", maxWidth: "100%", minHeight: 400 }}
              />
            </div>
            <div className="col-md-7 d-flex flex-column justify-content-center align-items-start">
              {isLayoutLoading ? (
                Array.from({ length: 1 }).map((_, index) => (
                  <div
                    className="skeleton w-100 mb-2"
                    style={{ width: "100%", maxWidth: "100%", height: 35 }}
                  ></div>
                ))
              ) : (
                <>
                  <h1> {layout.collection_heading}</h1>
                  <p>{layout.collection_paragraph}</p>
                  <div className="bg-primary p-4 rounded text-white position-realtive ">
                 <h4 className="text-white"> Dr. Arun Kumar Garg  </h4> 
               <p className="m-0 p-0"> Director & Consultant Clinical Cardiology </p>   
                  </div>
                </>
              )}
            </div>
          </div>
          <br />
        </div>


     <div className="container mt-4">
           <Swiper
             breakpoints={{
               300: {
                 slidesPerView: 3,
                 spaceBetween: 10, // Set the gap between slides for window width <= 400px
               },
               768: {
                 slidesPerView: 4,
                 spaceBetween: 15, // Set the gap between slides for window width <= 768px
               },
               992: {
                 slidesPerView: 6,
                 spaceBetween: 15, // Set the gap between slides for window width <= 992px
               },
               1200: {
                 slidesPerView: 6,
                 spaceBetween: 20, // Set the gap between slides for window width <= 1200px
               },
             }}
             pagination={true}
             modules={[Pagination, Navigation]}
             className="swiper-wrapper"
           >
             {isLayoutLoading
               ? Array.from({ length: 6 }).map((_, index) => (
                 <SwiperSlide>
                   <div
                     className="skeleton w-100"
                     style={{
                       width: "100%",
                       maxWidth: "100%",
                       height: "auto",
                       aspectRatio: "1/0.4",
                     }}
                   ></div>
                 </SwiperSlide>
               ))
               : layout.service_logos && (
                 <>
                   {layout.service_logos.map((image, index) => (
                     <SwiperSlide
                       key={index}
                       to={image.imageUrlInput}
                       className="container my-4 py-2 d-block"
                     >
                       <Link to={image.imageUrlInput}>
                         <img
                           src={image.imageInput}
                           width="100%"
                           alt=""
                           className="w-100"
                         />
                       </Link>
                     </SwiperSlide>
                   ))}
                 </>
               )}
           </Swiper>
         </div>



      </main>



 
      <Footer />
    </>

  )
}

export default HomeLocation
